export default {
  computed: {
    transportPassIsIssued() {
      return Boolean(this.visitor.transports[this.transportIndex].isIssued)
    },

    visibleTransportIssuePassButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport.give_pass &&
        !this.cfgMenuTransport.give_pass_period &&
        !this.transportPassIsIssued
      )
    },

    visibleTransportIssuePassPeriodButton() {
      return Boolean(
        this.visitor.access === 0 &&
        !this.cfgMenuTransport.give_pass &&
        this.cfgMenuTransport.give_pass_period &&
        !this.transportPassIsIssued
      )
    },

    visibleTransportPrintPassButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport.give_pass &&
        !this.cfgMenuTransport.give_pass_period &&
        this.transportPassIsIssued
      )
    },

    visibleTransportPrintPassPeriodButton() {
      return Boolean(
        this.visitor.access === 0 &&
        !this.cfgMenuTransport.give_pass &&
        this.cfgMenuTransport.give_pass_period &&
        this.transportPassIsIssued
      )
    },

    visibleTransportSendToSolvoButton() {
      return Boolean(this.visitor.access === 0 && this.cfgMenuTransport.send_to_solvo)
    },

    visibleTransportSendToSkudButton() {
      return Boolean(this.inScud === false && this.cfgMenuTransport.send_to_scud)
    },

    inScud() {
      return Boolean(Number(this.transport.inScud) === 1)
    }
  },

  methods: {
    setTypeahead(transport, typeaheadList, carTypeahead) {
      const result = []
      for (const list of typeaheadList) {
        if (list.id_car_type === transport.type) {
          result.push(list)
        }
      }

      if (result.length > 0) {
        carTypeahead = result
      }

      return carTypeahead
    }
  }
}
